import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allExaminations: [],
    loading: false,
    error: null,
};

const examinationsSlice = createSlice({
    name: 'examinations',
    initialState,
    reducers: {
        setAllExaminations: (state, action) => {
            state.allExaminations = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllExaminations } = examinationsSlice.actions;

export default examinationsSlice.reducer;